// import React from 'react'
// import { ArrayRender } from '../../../common/ArrayRender/ArrayRender'
// import { useState, useEffect } from 'react'
// import useSearchMember from '../../../../hooks/fetchUsers'
// import { useSelector } from 'react-redux'
// import { AdvanceSearcherComponent } from '../SearcherComponents/AdvanceSearcherComponent'
// import { MemberService } from '../../../../services/MemberService'
// import { advanceSearchEschema } from '../SearcherComponents/advanceSearchSchema'
// import logger from '../../../../utils/logger'
// import { ActiveSearchComponent } from '../SearcherComponents/ActiveSearchComponent'
// import { activeSearchEschema } from '../SearcherComponents/activeSearchSchema'


// import ProgressBar from 'react-bootstrap/ProgressBar';
// import { CardsContainer } from '../../../common/CardsContainer/CardsContainer'
// import { FormationCards } from '../../../common/FormationCards/FormationCards'
// import { LoadingComponent } from '../../../common/LoadingComponent/LoadingComponent'


// export const LayoutRender = ({ activeTab, showSearchBtn }) => {

//     const [formationData, setFormationData] = useState([]);


//     const URL = 'Formation'

//     const handleData = (d) => {
//         setFormationData(d)
//     }

//     // useEffect(() => {
//     //     setFormationData([])
//     // }, [showSearchBtn])


//     logger.debug('FORMATION DATA: ', formationData)
//     // logger.debug('FORMATION DATA LENGTH: ', formationData.items)


//     return (


//         <div className=' m-4'>

//             {showSearchBtn
//                 ?

//                 <AdvanceSearcherComponent
//                     searchSchema={advanceSearchEschema}
//                     handleData={handleData}
//                     url={URL}
//                     showSearchBtn={showSearchBtn}

//                 />
//                 :

//                 <ActiveSearchComponent
//                     searchSchema={activeSearchEschema}
//                     handleData={handleData}
//                     url={URL}
//                     showSearchBtn={showSearchBtn}
//                     activeTab={activeTab}
//                 />
//             }




//             <ArrayRender
//                 layoutRender={

//                     <CardsContainer CardComponent={FormationCards} />
//                 }
//                 data={formationData}
//             />




//         </div>




//     )
// }





import React from 'react'
import { ArrayRender } from '../../../common/ArrayRender/ArrayRender'
import { useState, useEffect } from 'react'
import useSearchMember from '../../../../hooks/fetchUsers'
import { useSelector } from 'react-redux'
import { AdvanceSearcherComponent } from '../SearcherComponents/AdvanceSearcherComponent'
import { MemberService } from '../../../../services/MemberService'
import { advanceSearchEschema } from '../SearcherComponents/advanceSearchSchema'
import logger from '../../../../utils/logger'
import { ActiveSearchComponent } from '../SearcherComponents/ActiveSearchComponent'
import { activeSearchEschema } from '../SearcherComponents/activeSearchSchema'


import ProgressBar from 'react-bootstrap/ProgressBar';
import { CardsContainer } from '../../../common/CardsContainer/CardsContainer'
import { FormationCards } from '../../../common/FormationCards/FormationCards'
import { LoadingComponent } from '../../../common/LoadingComponent/LoadingComponent'


export const LayoutRender = ({ activeTab, showSearchBtn, renderUsers,loading, handleLoading,totalFiltered,handleFiltered }) => {

    const [formationData, setFormationData] = useState([]);

    // const [totalFiltered, setTotalFiltered] = useState(null)


    const URL = 'Formation'

    const handleData = (d) => {
        setFormationData(d)
    }

    // const handleFiltered = (f) => {
    //     setTotalFiltered(f)
    // }

    // useEffect(() => {
    //     setFormationData([])
    // }, [showSearchBtn])


    logger.debug('FORMATION DATA: ', formationData)
    // logger.debug('FORMATION DATA LENGTH: ', formationData.items)


    return (


        <div className=' m-4'>

            {showSearchBtn
                ?

                <AdvanceSearcherComponent
                    searchSchema={advanceSearchEschema}
                    handleData={handleData}
                    url={URL}
                    showSearchBtn={showSearchBtn}
                    handleFiltered ={handleFiltered }
                    handleLoading={handleLoading}
                   

                />
                :

                <ActiveSearchComponent
                    searchSchema={activeSearchEschema}
                    handleData={handleData}
                    url={URL}
                    showSearchBtn={showSearchBtn}
                    activeTab={activeTab}
                    renderUsers={renderUsers}
                    handleFiltered ={handleFiltered }
                   
                />
            }




            <ArrayRender
                totalFiltered={totalFiltered}
                layoutRender={

                    <CardsContainer CardComponent={FormationCards} />
                }
                data={formationData}
                loading={loading}
            />




        </div>




    )
}
